import { gql } from 'graphql-tag';
import { GET_STUDENTS_BASE } from './getStudentsBase';
import type { IGetAllStudentsForEditRoomData } from '../types';

export const GET_ALL_STUDENTS_FOR_EDIT_ROOM = GET_STUDENTS_BASE<IGetAllStudentsForEditRoomData>({
  student: gql`
    fragment Student on StudentType {
      id
      groupType
    }
  `,
});
